import React, { useState } from 'react';
import css from './FAQPage.module.css';
import { H3, H4, LayoutSideNavigation, LayoutSingleColumn, Page } from '../../components';
import FooterContainer from '../FooterContainer/FooterContainer';
import TopbarContainer from '../TopbarContainer/TopbarContainer';
import { FaChevronUp, FaChevronDown } from 'react-icons/fa';
import { isScrollingDisabled } from '../../ducks/ui.duck';
import classNames from 'classnames';

const faqs = [
  {
    key: 'account',
    label: 'YOUR ANIMAL LIST ACCOUNT',
    qna: [
      {
        ques: 'How do I create an account on The Animal List?',
        ans:
          "<p>To create an account, click on the 'Join' button on the homepage. Follow the prompts to provide your details, including a valid email address. Once completed, you'll receive a confirmation email to activate your account.</p>",
      },
      {
        ques: 'How do I edit my profile/ Petfolio information?',
        ans:
          "<p>Log in to your account, click your user icon (top right), go to your profile settings, and update the necessary information. Make sure you select the 'Save Changes' button. Some of this information is also listed on your public profile, what we call a PETfolio. That includes your description, photo, website, and display name. NOTE: You can share your PETfolio that includes all of your listings.</p>",
      },
      {
        ques: 'What should I do if I forget my password?',
        ans:
          "<p>Log in to your account, click your user icon (top right), Click on the 'Account settings', then click 'Password' link. Change your password and select 'Save Changes'.</p>",
      },
      {
        ques: 'Can you remove my data?',
        ans:
          "<p>In order to have your data removed or deleted from The Animal List, please email <a href='mailto:eric@petsonq.com'>eric@petsonq.com</a>.</p>",
      },
    ],
  },
  {
    key: 'buying',
    label: 'BUYING ON THE ANIMAL LIST',
    qna: [
      {
        ques: 'How do I hire animal talent on The Animal List?',
        ans:
          "<p>You have two options. You can either create a casting call for animal talent to apply to your job, or you can utilize the search bar and browse categories to explore a diverse range of animal talent. Enhance your search by applying filters such as location, skills, and reviews to find the ideal match for your job. Once you have selected the animals listing that you want to hire. Select the package, date and add-ons that best fit your needs, then select the 'Request to Book' button on the right hand side of the listing.</P>",
      },
      {
        ques: 'What is a casting call?',
        ans:
          "<p>A casting call is a posting on The Animal List where individuals or companies can announce their need for specific animal talents for various jobs. It's an open invitation for agencies, wranglers, or animal owners to apply with their animals for consideration.</p>",
      },
      {
        ques: 'How do I create them on The Animal List?',
        ans: `<p>To create a casting call make sure you are on the buyers page, if not select 'Switch to Buyer' next to your Profile icon. Then post a casting call will appear in the top right corner. There is also a button on the main home page. To create a casting call:</p>
          <br/>
          <ol>
            <li>Log in to your account on The Animal List.</li>
            <li>Navigate to the 'Post Casting Call' button. If you see 'Post a Listing' select 'Switch to Buyer' next to your profile icon to see 'Post a Casting Call'.</li>
            <li>Provide detailed information about your job, including the type of animals needed, specific requirements, and any other relevant details.</li>
            <li>Set parameters such as location, skills, and availability to narrow down the selection.</li>
            <li>Review and confirm the details before submitting your casting call.</li>
          </ol>
           <p>Once your casting call is live, interested animal owners and trainers can apply with their animals, and you'll have the opportunity to review and select the most suitable candidates for your job.</p>         
          `,
      },
      {
        ques: 'When am I charged for a job?',
        ans:
          "<p>The buyer's credit card will be put on hold upon selection. The charge will only be processed once the terms are accepted by the seller. The funds are not released to the animal talent seller until the buyer marks the job as completed or 14 days have passed from the agreed upon end date.</p>",
      },
      {
        ques: 'How many castings can I create?',
        ans:
          '<p>On The Animal List, there is no set limit to the number of castings you can create. You have the flexibility to post as many castings as needed to find the perfect animal talent for your jobs. Whether you have multiple projects in the pipeline or are searching for specific skills, feel free to create as many castings as required to meet your unique needs. Note: close your listings that are no longer active.</p>',
      },
      {
        ques: 'Where is my casting listed? How can I share it?',
        ans:
          "<p>Your castings are prominently listed on The Animal List platform, they are also accessible in your dashboard. To share them: log in to your account on The Animal List. Navigate to the profile icon and select 'Dashboard. Locate the casting you wish to share and click on it to view the details. Copy the hyperlink at the top of the page. Share the casting link via email, social media, or any preferred communication channel to reach a wider audience. By sharing your casting, you increase its visibility and enhance the chances of finding the perfect animal talent for your job.</p>",
      },
      {
        ques: 'How do I place an order for animal talent for my job?',
        ans:
          "<p>Find an animal you're interested in, select the package, add ons and date that works best for you. Then click 'Request to book,' and follow the prompts to provide necessary details, including payment details. Once the animal talent seller accepts, their animal talent is placed on hold for that day, and the charge will go through to confirm the job. Please note, the payment is not released until the job is marked completed by the buyer or 14 days has gone past the completion date.</p>",
      },
      {
        ques: 'How do I leave a review for a job once completed?',
        ans:
          '<p>Once the job is finalized, you have the opportunity to leave a review on the animal talent seller’s profile. Please be honest, providing constructive feedback contributes to fostering a reliable and transparent community on The Animal List.</p>',
      },
      {
        ques: 'What happens if I am not satisfied with a job?',
        ans:
          '<p>If you are dissatisfied with a job, we recommend reaching out to the animal talent seller to address and resolve any issues. In cases where an agreement cannot be reached, our dedicated customer support team is ready to mediate the situation. You can also utilize the dispute resolution feature available on The Animal List to help facilitate a fair resolution.</p>',
      },
    ],
  },
  {
    key: 'selling',
    label: 'SELLING/LISTING ON THE ANIMAL LIST',
    qna: [
      {
        ques: 'How do I become an Animal Talent Seller on The Animal List?',
        ans:
          "<p>To become a seller on The Animal List, begin by signing up, crafting a comprehensive PETfolio, and list your animal talent services for potential jobs. Your PETfolio highlights all of your listings, you'll then gain the ability to commence offering your services and earning income as freelance animal talent.</p>",
      },
      {
        ques: 'What is a listing on The Animal List?',
        ans:
          '<p>A listing on The Animal List refers to a particular animal talent service provided by an animal talent seller. These listings encompass a wide range of animal talent based services, spanning from animal acting, to search and rescue, content creation and specialized offerings by animal professionals, such as transporters or pet photographers AND so much more.</p>',
      },
      {
        ques: 'How do I create a listing as an Animal Talent Seller?',
        ans: `<p>Creating a listing as a seller on The Animal List is a straightforward process:</p>
          <ol>
            <li>Log in to your account on The Animal List.</li>
            <li>Navigate to the 'Post Animal Listing' button. If you see 'Post a Casting Call', click 'Switch to Buyer'.</li>
            <li>Provide detailed information about your animal talent service, including the type of service you offer, your expertise, and any relevant details.</li>
            <li>Set pricing for your service and include any additional information that potential buyers may find valuable.</li>
            <li>Add high-quality images or videos showcasing your animal talent to enhance your listing's appeal.</li>
            <li>Preview your listing to ensure accuracy and completeness.</li>
            <li>Once satisfied, submit your listing for review.</li>
          </ol>

          <p>Upon approval, your listing will be live on the platform, allowing potential buyers to discover and engage with your unique animal talent services. If your listing includes a certification for animal acting it will need to be verified by your affiliated party.</p>
      
          `,
      },
      {
        ques: 'Is there a vetting process for sellers?',
        ans:
          '<p>While not mandatory for all sellers, we require that Animal Agencies, Wranglers, and Animal Actors obtain specific certifications and undergo a thorough vetting process on The Animal List to meet our standards. This process involves a meticulous review of profiles, verification of references, and, in certain instances, in-person evaluations to ensure adherence to our quality standards. We do this to ensure the animals booked for a production job are healthy, able to complete the job and happy while doing it.</p>',
      },
      {
        ques: 'Can I offer listings for multiple animals under one profile?',
        ans:
          '<p>Certainly! You have the flexibility to present services for multiple animals within every listing. Each listing you generate will be conveniently saved to your PETfolio for easy access and management. If you have a herd of goats, a cat animal actor, or represent twenty pet creators you have unlimited listings and possibilities.</p>',
      },
      {
        ques: 'How do I set my prices for services?',
        ans:
          '<p>As a seller, you have the freedom to determine your prices. Take into account factors such as the complexity of the task, your expertise, and the distinctiveness of your animal talent. For example, for entry-level animal actors, the recommended pricing typically falls around $250 per day. Influencers may have varied rates based on the quality of their audience, followers, platform and engagement rate. For further guidance, we encourage you to explore our educational community, <a href="https://www.petstars.com/">Pet Stars Academy</a>.</p>',
      },
      {
        ques: 'How do I apply for a casting call?',
        ans:
          "<p>To apply for a casting call, simply choose one that aligns with your interests and click on it to begin the application process. Select the 'Send an Inquiry' button on the right-hand side. When applying, include a listing link for the buyer's review. This link offers a convenient way for them to assess your animal, view your ratings, and explore the package pricing options you have available.</p>",
      },
      {
        ques: "Can I edit the details of a listing once it's published?",
        ans:
          "<p>Certainly! You have the flexibility to edit the details of your listing at any time. Simply click your profile icon, navigate to 'Dashboard' section and find the specific listing you wish to modify. Edit listing is listed under the listing.</p>",
      },
      {
        ques: 'How many listings can I have?',
        ans: '<p>At this time there is no limit on the number of listings.</p>',
      },
      {
        ques: 'What are packages and add ons?',
        ans:
          '<p>Each listing has the option to have up to three offerings or packages for a potential buyer to purchase. They should be at different rates, have different descriptions and inclusions. In addition you can set rates for add-ons or extras for the buyer to include at your own set rates. IE. overtime, transportation, whitelisting, exclusivity for 3 months etc.</p>',
      },
      {
        ques: 'Can I cancel an order?',
        ans:
          "<p>We recommend discussing any concerns or questions with the other parties involved before confirming the order to prevent misunderstandings. In the event of issues, and if you absolutely must cancel, please reach out to our customer support team for assistance. We're here to help resolve any issues that may arise during the process.</p>",
      },
    ],
  },
  {
    key: 'payment',
    label: 'PAYMENT',
    qna: [
      {
        ques: 'How to set up Payment or Payout details?',
        ans:
          "<p>Simply log into your account. Click on your profile icon in the top right and select 'Account Settings'. If you are an animal talent buyer, select payment methods for faster transactions or complete the information at each booking of animal talent. If you are an animal talent seller and wish to be paid out, select 'Payout Details' and add your account information for direct payment. We utilize Stripe to securely hold and process payments, ensuring a safe and reliable transaction experience for all users.</p>",
      },
      {
        ques: 'How does payment work on The Animal List?',
        ans:
          "<p>Payment for services are securely processed through our system. Buyers are not charged until all parties involved in the transaction are confirmed. After the job is successfully completed, or 14 days goes beyond the completion date, the payment is released to the seller's account. We utilize Stripe to securely hold and process payments, ensuring a safe and reliable transaction experience for all users.</p>",
      },
      {
        ques: 'Are there any additional fees on top of the service price?',
        ans:
          '<p>The listing price provided by the seller includes any add-ons and inclusions in packages, ensuring transparency. In some cases, additional costs (such as overtime) may occur if mutually agreed upon and the seller will be transparent about them. All transactions are subject to a 5% payment fee. Additionally, The Animal List is compensated by a 15% platform fee paid by the animal talent seller. All fees will be deducted prior to the issuance of payment to the seller.</p>',
      },
      {
        ques: 'When does payment happen',
        ans:
          '<p>Payment occurs when a job is completed and marked as such by the buyer within our system. Additionally, if not marked by the buyer, the system will automatically complete the transaction 14 days from the last booking date. This ensures that payments are processed in a timely manner and reflects the completion of the service.</p>',
      },
      {
        ques: 'Are there any cancellation fees',
        ans:
          "<p>In the event of a cancellation, it's advisable to address any concerns with the seller beforehand to prevent misunderstandings. If you're the animal talent buyer initiating the cancellation, please note that it may incur a 5% fee. However, if you're the animal talent seller, no fee will be applied to your account. Nevertheless, repeated cancellations may result in strikes being placed on your account. Accumulating three strikes can lead to the closure of your account. We encourage clear communication to minimize the need for cancellations and ensure a positive experience for all parties involved.</p>",
      },
    ],
  },
];
const FAQPage = props => {
  const { scrollingDisabled } = props;
  const [acc, setAcc] = useState([]);
  const mainContent = (
    <div>
      {faqs.map(faq => (
        <div className={css.faqcats}>
          <H4>{faq.label}</H4>
          <ul className={css.qnaul}>
            {faq.qna.map(qa => (
              <li>
                <button
                  className={css.accdr}
                  onClick={e => {
                    const isIncl = acc.includes(qa.ques);
                    const ansDiv = document.getElementById(qa.ques);
                    if (isIncl) {
                      setAcc(acc.filter(q => q !== qa.ques));
                      ansDiv.style.maxHeight = null;
                    } else {
                      setAcc([...acc, qa.ques]);
                      ansDiv.style.maxHeight = ansDiv.scrollHeight + 20 + 'px';
                    }
                  }}
                >
                  {qa.ques} {acc.includes(qa.ques) ? <FaChevronUp /> : <FaChevronDown />}
                </button>
                <div
                  id={qa.ques}
                  className={classNames(css.ansp, { [css.showans]: acc.includes(qa.ques) })}
                  dangerouslySetInnerHTML={{ __html: qa.ans }}
                ></div>
              </li>
            ))}
          </ul>
        </div>
      ))}
    </div>
  );
  return (
    <Page title={'FAQ Page'} scrollingDisabled={scrollingDisabled}>
      <LayoutSingleColumn
        topbar={
          <TopbarContainer
            currentPage="FAQPage"
            desktopClassName={css.desktopTopbar}
            mobileClassName={css.mobileTopbar}
          />
        }
        currentPage="FAQPage"
        footer={<FooterContainer />}
      >
        <div className={css.root}>
          <H3 as="h1">FAQs</H3>
          {mainContent}
        </div>
      </LayoutSingleColumn>
    </Page>
  );
};
const mapStateToProps = state => {
  return {
    scrollingDisabled: isScrollingDisabled(state),
  };
};
export default FAQPage;
